<template>
  <div ref="share" data-test="us-share-button" class="us-share-button">
    <USButton
      is="button"
      :type="variation === 'icon-circle' ? 'icon-circle' : 'inline'"
      :label="label"
      icon="share"
      @click="ShareEvent"
    />
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import USButton from '@base/components/USButton/USButton.vue'
import { Share } from '@base/@motiv/fe-patterns'

export default defineComponent({
  name: 'USShareButton',
  components: { USButton },
  props: {
    label: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    shareUrl: { type: String, required: true },
    shareTitle: { type: String, default: '' },
    shareText: { type: String, default: '' },
    variation: {
      type: String,
      default: 'default',
      validator: (value: string) => {
        return ['default', 'icon-circle'].includes(value)
      }
    }
  },
  emits: ['ShareEvent', 'succuss'],
  setup(props, { emit }) {
    const ShareEvent = async () => {
      let shareURL = `${props.shareUrl}`
      let result = await Share.share({
        url: shareURL,
        title: props.shareTitle,
        text: props.shareText
      })
      emit('ShareEvent', { result })
      if (!result && shareURL) {
        navigator.clipboard.writeText(shareURL.toString())
        emit('succuss')
      }
    }

    return { ShareEvent }
  }
})
</script>

<style lang="scss" scoped>
@use '@base/styles/v1.0/scss/elements/grid';

.us-share-button {
  display: inline-block;
}
</style>
